const templates = [
    {
        'id': 0,
        'template': '当{{subspace}}时，总体看， {{measure1}} 和 {{measure2}} 之间存在 {{正/负}} 相关关系.',
    },
    {
        'id': 1,
        'template': '当{{subspace}}时，总体看， {{measure1}} 和 {{measure2}} 呈 {{正/负}} 相关.',
    },
    {
        'id': 2,
        'template': '当{{subspace}}时，总体看， {{measure1}} 和 {{measure2}} 呈 {{正/负}} 相关（皮尔森相关系数={{parameter}}）.',
    }
]

export default templates;